// Dependencies
import moment from "moment";

/**
 * Forces 'value' to be a moment in order to handle dates and moments
 */
const coerceToDateObject = (value) => {
	if (moment.isMoment(value)) {
		if (value.isValid()) {
			return value.toDate();
		}
		return "";
	} else if (value instanceof Date) {
		return value;
	} else if (typeof value === "string") {
		const coerced = moment(value);
		if (coerced.isValid()) {
			return coerced.toDate();
		}
		return "";
	}

	return "";
};

export default coerceToDateObject;
